import { render, staticRenderFns } from "./sorting-select.vue?vue&type=template&id=b28873e8&scoped=true"
import script from "./sorting-select.vue?vue&type=script&lang=js"
export * from "./sorting-select.vue?vue&type=script&lang=js"
import style0 from "./sorting-select.vue?vue&type=style&index=0&id=b28873e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28873e8",
  null
  
)

export default component.exports